<template>
  <div class="select-wrapper">
    <div class="select-container">
      <div class="container-title">현장 선택</div>
      <div class="d-flex justify-end my-4 ">
        <div class="status-wrapper">
          <v-select
            v-model="constructionStatus"
            :items="statusList"
            height="40"
            solo
            flat
            dense
            hide-details
            item-color="blue darken-1"
            append-icon="mdi-chevron-down"
            :menu-props="{ offsetY: true }"
            @change="onChangeConstructionStatus"
            v-resize="updateWindowHeight"
          />
        </div>
      </div>

      <div class="table-grid w-full pr-2 bg-blud">
        <div
          v-for="(header, headIdx) in tableHeaderList"
          :key="header + headIdx"
          :class="{
            'first-header': headIdx === 0, // 첫 번째 요소
            'align-center': headIdx <= 2,
            'last-header': headIdx === tableHeaderList.length - 1, // 마지막 요소
            'table-header flex-column': true,
            'pr-6': headIdx === 5,
          }"
        >
          {{ header }}
          <span v-if="headIdx === 3">{{ dayBeforeYesterday }}</span>
          <span v-if="headIdx === 4">{{ yesterday }}</span>
        </div>
      </div>

      <div class="table-grid sum-wrapper pr-2">
        <div class="pa-4 d-flex justify-center">합계</div>
        <div class="pa-4">&nbsp;</div>
        <div class="pa-4">&nbsp;</div>
        <div class="pa-4">&nbsp;</div>
        <div class="pa-4">&nbsp;</div>
        <div class="pa-4 d-flex justify-end pr-6">{{ totalSum }}</div>
      </div>

      <ul class="area-ul" :style="{ height: windowInnerHeight - 360 + 'px' }">
        <li
          v-for="area in areaList"
          :key="area.constructionId"
          class="table-grid w-full area-li"
          @click="onSelectArea(area)"
        >
          <div class="pa-4 area-div justify-center">
            {{ area.constructionName }}
          </div>
          <div class="pa-4 area-div justify-center">
            {{ area.startDate ? fotmatDate(area.startDate) : "-" }}
          </div>
          <div class="pa-4 area-div justify-center">
            {{ area.endDate ? fotmatDate(area.endDate) : "-" }}
          </div>
          <div class="pa-4 area-div justify-end">
            {{ area.dayBeforeYesterday.sum.toLocaleString("ko-KR") }}
          </div>
          <div class="pa-4 area-div justify-end">
            {{ area.yesterday.sum.toLocaleString("ko-KR") }}
          </div>
          <div class="pa-4 area-div justify-end">
            {{ area.yesterdayTotal.toLocaleString("ko-KR") }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ConstAPI from "@/api/ConstructionService";
import RebarAPI from "@/api/RebarService";
import UserAPI from "@/api/UserService";
import moment from "moment";

export default {
  props: ["loginId", "constId"],
  data: () => ({
    statusList: ["전체", "시공대기", "시공중", "시공완료"],
    constructionStatus: "전체",
    tableHeaderList: [
      "현장선택",
      "착공일",
      "준공일",
      "누적 입고량",
      "누적 입고량",
      "반입량",
    ],
    areaList: [],
    initAreaList: [],
    selectArea: null,
    totalSum: 0,
    windowInnerHeight: 0,
    yesterday: 0,
    dayBeforeYesterday: 0,
    today: moment(),
  }),
  computed: {
    constructionId() {
      return this.$store.state.Const.constructionId.constructionId ?? "";
    },
    roleType() {
      return this.$store.getters.getUserList.roleType;
    },
    userId() {
      return this.$store.getters.getUserList.userId;
    },
  },
  async mounted() {
    await this.getAreaList();
    await this.initSetting();
  },
  methods: {
    fotmatDate(date) {
      return moment(date).format("YY.MM.DD");
    },
    /** 현장목록 조회 */
    async getAreaList() {
      try {
        const { data } = await ConstAPI.constructionListOnUser({
          userId: this.userId ? this.userId : this.loginId,
        });
        this.areaList = data.constListonUser;
        this.initAreaList = data.constListonUser;
        this.totalSum = data.constListonUser.reduce(
          (acc, cur) => acc + cur.yesterdayTotal,
          0
        );
        this.yesterday = moment(data.constListonUser[0].yesterday.date).format(
          "YY.MM.DD"
        );
        this.dayBeforeYesterday = moment(
          data.constListonUser[0].dayBeforeYesterday.date
        ).format("YY.MM.DD");
      } catch (e) {
        console.error(e);
      }
    },
    async initSetting() {
      this.constsId = 0;

      if (this.initAreaList?.length === 0) {
        if (this.roleType === "시스템관리자") {
          this.$store.commit("userStateChange", this.roleType);
          this.$router.push({ name: "Construction" });
        }
        this.$bus.$emit(
          "dialog",
          "소속된 현장이 없습니다. 로그인화면으로 돌아갑니다."
        );
        await UserAPI.userLogout();
        this.$router.push({ name: "Login" });
        return;
      }

      if (this.constId || this.roleType === "현장관리자") {
        let { data } = await ConstAPI.constructionInformation({
          constructionId: this.constId
            ? this.constId
            : this.initAreaList[0].constructionId,
        });
        this.$store.commit("constructionIdChange", {
          constructionId: this.constId
            ? this.constId
            : this.initAreaList[0].constructionId,
          constructionName: data.constInformation[0].constructionName,
        });
        if (this.roleType === "현장관리자") {
          if (this.initAreaList.length === 1)
            this.constsId = this.initAreaList[0].constructionId;
        }
        if (this.initAreaList.length === 1)
          this.onSelectArea(this.initAreaList[0]);
      }
    },
    async selectBase() {
      this.$store.commit("userStateChange", this.roleType);
      const { data } = await RebarAPI.rebarList({
        constructionId: this.constsId
          ? this.constsId
          : this.constId ?? this.selectArea.constructionId,
      });
      this.$store.commit("rebarListChange", data.RebarList); // 대시보드 미리 세팅
    },
    onSelectArea(area) {
      const roleTypeRoutes = {
        시스템관리자: "DashBoard",
        발주담당자: "Order",
        현장관리자: "DashBoard",
        입고담당자: "Invoice",
        뷰어: "DashBoard",
      };
      const route = roleTypeRoutes[this.roleType];

      this.selectArea = area;
      this.selectBase();
      this.$store.commit("constructionIdChange", area); // 현장 스토어
      this.$router.push({ name: route });
    },
    /** 시공상태 핸들러 */
    onChangeConstructionStatus(status) {
      if (status === "전체") {
        this.areaList = this.initAreaList;
        return;
      }

      const filtered = this.initAreaList.filter(
        (area) => area.completion === status
      );
      this.areaList = filtered;
    },
    /** 윈도우 동적높이 가져오는 함수 */
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
  },
};
</script>
<style lang="css" scoped>
* {
  font-family: "Noto Sans KR";
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
::v-deep .v-select__selection {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.select-wrapper {
  background-image: url("/static/main/select-area-bg.png");
  background-size: cover;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.select-container {
  height: 94dvh;
  width: 70%;
  border-radius: 15px;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(7.5px);
  padding: 32px;
  @media screen and (max-width: 600px) {
    padding: 12px 16px;
  }
}
.container-title {
  font-size: 22px;
  font-weight: 700;
  @media screen and (max-width: 600px) {
    font-size: 16px;
  }
}
.table-grid {
  display: grid;
  grid-template-columns: 0.3fr 0.1fr 0.1fr 0.18fr 0.18fr 0.14fr;
}
.bg-blud {
  background-color: #8ca9dd;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.table-header {
  display: flex;
  justify-content: center;
  align-items: end;
  padding: 16px;
  color: white;
  background-color: #8ca9dd;
  font-size: 16px;
  font-weight: 700;
  @media screen and (max-width: 600px) {
    font-size: 14px;
    padding: 8px;
  }
}
.first-header {
  border-top-left-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.last-header {
  border-top-right-radius: 10px;
}
.w-full {
  width: 100%;
}
.sum-wrapper {
  color: #222222;
  background: rgba(236, 236, 236, 0.65);
  font-weight: 500;
}
.area-ul {
  /* height: 580px; */
  overflow-y: scroll;
  background-color: white;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
.area-ul::-webkit-scrollbar {
  width: 10px;
  background: transparent;
}
.area-ul::-webkit-scrollbar-track {
  background-color: transparent;
}
.area-ul::-webkit-scrollbar-thumb {
  border-radius: 4px;
}
.area-ul::-webkit-scrollbar-thumb:hover {
  background-color: rgba(87, 87, 87, 0.5);
}
.area-li {
  cursor: pointer;
  border-bottom: 1px solid #ececec;
  &:hover {
    background: rgba(140, 169, 221, 0.35);
  }
}
.area-div {
  font-size: 16px;
  font-weight: 500;
  display: flex;
  @media screen and (max-width: 600px) {
    font-size: 14px;
  }
}
.status-wrapper {
  width: 322px;
  @media screen and (max-width: 600px) {
    width: 150px;
  }
}
</style>
